import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

export const AuthSetupGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  try {
    if (authService.userValue?.email)
      return true;
    const result = await authService.setUserData();
    return result;
  } catch (error) {
    return false;
  }
};
